import {
  PARTNER_REGISTER_FAIL,
  PARTNER_REGISTER_REQUEST,
  PARTNER_REGISTER_SUCCESS,
} from "../Constants/bizDevConstants";
import api from "../service/api";

export const partnerRegister =
  (fullName, email, location, password, isPartner, commision, accountType) =>
  async (dispatch) => {
    try {
      dispatch({ type: PARTNER_REGISTER_REQUEST });
      const { data } = await api.post(
        `api/users/partner-register`,
        {
          fullName,
          email,
          location,
          password,
          isPartner,
          commision,
          accountType,
        }
      );
      dispatch({ type: PARTNER_REGISTER_SUCCESS, payload: data });
    } catch (error) {
      const errorMessage = error.response
        ? error.response.data.message
        : error.message;
      dispatch({
        type: PARTNER_REGISTER_FAIL,
        payload: errorMessage,
      });
    }
  };
